<template>
  <div class="defaultLayoutContainer wrapper appWrapper">
    <keep-alive :include="keepAlive">
      <c-loading-screen v-if="loading"></c-loading-screen>
      <router-view v-else class="viewContainer" id="routerViewport"></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  props: { keepAlive: { default: () => [], type: Array }, loading: { type: Boolean } },
}
</script>
